<template>
<div class="one-message-step" style="z-index: 2001;" v-if="dataForm.step == '00'">
    <div class="title">
        <ab-svg name="gantanhao"></ab-svg>
        温馨提示： 尊敬的客户，欢迎您来到一咻通关！在下单前，需要您先用约5分钟时间完成签约，请点击 
        <span @click="firstStep">"立即签约"</span>继续。
    </div>
    <ab-title title="平台介绍" class="introduction">
        <div class="content-box">
            <el-row :gutter="30" style="height: 240px">
                <el-col :span="12">
                    <div class="introduction-img"></div>
                </el-col>
                <el-col :span="12">
                    <div class="introduction-text">
                        <h2>一咻通关 . 自助通关平台开拓者</h2>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;一咻通关是由全国供应链示范企业精心打造的全国首家全品类、全场景的智能化自助通关平台。基于人工智能（AI）、大数据、区块链等高新技术，一咻通关围绕中小企业的进出口订单交付，解决全流程痛点，降低运营成本，规避关务、税务风险，让企业的进出口通关变得省时省心。
                        </p>
                        <ul>
                            <li :class="{li: true, 'last-li': index == platformList.length - 1}" v-for="(item, index) in platformList" :key="index" :style="{width: `${100 / platformList.length}%`}">
                                <div class="li-content">
                                    <div class="icon">
                                        <ab-svg :name="item.icon"></ab-svg>
                                    </div>
                                    <div class="title-info">{{item.title}}</div>
                                    <!-- <p>{{item.info}}</p> -->
                                </div>
                            </li>
                            <i class="clearfix"></i>
                        </ul>
                        <el-button type="primary" class="contract-button" @click="firstStep">立即签约</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
    </ab-title>
    <el-row :gutter="10" style="margin-top: 10px">
        <el-col :span="12">
            <ab-title class="core-technology" title="核心技术">
                <div class="content-box">
                    <el-row :gutter="30">
                        <el-col :class="{bottonLi: index < 2}" v-for="(item, index) in technologyList" :key="index" :span="48 / technologyList.length">
                            <div class="box-content">
                                <div class="title-text">
                                    <ab-svg :name="item.icon"></ab-svg>
                                    {{item.title}}
                                </div>
                                <p>{{item.info}}</p>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </ab-title>
        </el-col>
        <el-col :span="12">
            <ab-title class="joint-venture" title="合作企业">
                <div class="content-box">
                    <ul>
                        <li v-for="(item, index) in enterpriseList" :key="index">
                            <img :src=" require(`../../assets/img/sign/contract/enterprise/${item}`)">
                        </li>
                        <i class="clearfix"></i>
                    </ul>
                </div>
            </ab-title>
        </el-col>
    </el-row>
    <!-- <div class="footer">
        <el-button type="primary" @click="firstStep">立即签约</el-button>
    </div> -->
</div>
</template>

<script>
export default {
    data() {
        return {
            technologyList: [
                {
                    title: '人工智能',
                    icon: 'rengongzhineng',
                    info: 'AI导入与模板导入,图片/表格/PDF上传,15秒 秒速制单;自助力发起付汇，系统自动处理，资金不在平台停留。'
                },
                {
                    title: '大数据',
                    icon: 'dashuju',
                    info: '通关过程透明、可预期，全流程可视化查询，节点信息更全面、更清晰。'
                },
                {
                    title: '区块链',
                    icon: 'qukuailian',
                    info: 'AI报关15秒，云储存，区块链黑科技报关,让通关更高效，更迅速。'
                },
                {
                    title: '物联网',
                    icon: 'wulianwang',
                    info: '智能仓储的应用保证了货物仓库管理各个环节数据输入的速度和准确性，确保货物的安全及货物状态更新的及时性。'
                }
            ],
            platformList: [
                {
                    title: '清除风险',
                    icon: 'qingchufengxian',
                    info: '专业的事交给专业的人，规避关务税务风险。'
                },
                {
                    title: '省时省心',
                    icon: 'shengshishengxin',
                    info: '不用处理关检汇税等专业又繁杂的事。'
                },
                {
                    title: '稳定可靠',
                    icon: 'wendingkekao',
                    info: '自助服务随时响应，比人更及时、更可靠。 '
                },
                {
                    title: '提升盈利',
                    icon: 'tishengyingli',
                    info: '更好的服务，超低的价格，省下的都是净利。'
                },
                {
                    title: '助力发展',
                    icon: 'zhulifazhan',
                    info: '不仅垫付税款，还帮助客户获得银行融资，为客户持续发展赋能。'
                }
            ],
            enterpriseList: ['tengxun.png', 'jindieyun.png', 'Eqianbao.png', 'huaqiang.png', 'shandi.png', 'yuncang.png', 'xinyuncang.jpg', 'haikang.png', 'ningbo.png', ]
        }
    },
    props: {
        dataForm: {
            type: Object,
            defualt: {}
        }
    },
    methods: {
        firstStep () {
            let data = Object.assign({}, this.dataForm, {step: '01'})
            this.$parent.gotoStep(data).then(() => {})
        },
    },
}
</script>

<style lang="scss">
.one-message-step {
    background-color: #efeff1;
    z-index: 99999;
    &::-webkit-scrollbar{
        width: 3px;
    }
    //温馨提示
    .title{
        text-align: center;
        height: 50px;
        width: 100%;
        margin-bottom: 10px;
        box-shadow: -5px 1px 10px 0px rgba(0, 0, 0, 0.05);
        line-height: 50px;
        background-color: #fff;
        font-size: 14px;
        .ab-svg{
            float: left;
            margin-left: 30px;
            width: 14px;
            height: 14px;
            margin-top: 17px;
            margin-right: 8px;
        }
        span{
            cursor: pointer;
            color: #0b7aff;
        }
    }
    //平台介绍
    .introduction{
        .content-box{
            padding: 20px;
            background-color: #fff;
            .contract-button{
                animation: breathe 1.1s infinite;
                font-size: 12px;
            }
            @keyframes breathe{
                0%{ transform: scale(.9);}
                50%{ transform: scale(1.05);}
                100%{ transform: scale(.9);}
            }
            .introduction-img{
                height: 240px;
                background: url("../../assets/img/sign/contract/introduction.png");
                background-repeat: no-repeat;
                background-size: cover;
            }
            .introduction-text{
                h2{
                    color: #000;
                    font-size: 24px;
                    font-weight: bold;
                    margin: 0px 0 10px;
                    text-indent: 8px;
                }
                p{
                    font-size: 14px;
                    font-weight: 400;
                    color: #4D5155;
                    line-height: 21px;
                }
                .el-button{
                    height: 40px;
                    padding: 0 38px;
                    font-size: 16px;
                    margin-top: 10px;
                }
                ul{
                    width: calc(100% - 8vw);
                    .li{
                        float: left;
                        position: relative;
                        width: 20%;
                        height: 90px;
                        // padding-left: 30px;
                        background-color: #ffffff;
                        .li-content{
                            .icon{
                                width: 46px;
                                height: 46px;
                                // position: relative;
                                // left: 50%;
                                // margin-left: -32px;
                                background-color: #f1f6fa;
                                border-radius: 50%;
                                margin-top: 14px;
                                margin-bottom: 7px;
                                text-align: center;
                                .ab-svg{
                                    width: 20px;
                                    height: 21px;
                                    margin-top: 14px;
                                }
                            }
                            .title-info{
                                font-size: 14px;
                                font-weight: bold;
                                color: #000;
                                text-indent: -4px;
                            }
                            p{
                                font-size: 14px;
                                line-height: 20px;
                                font-weight: bold;
                                color: #000000;
                            }
                        }
                    }
                }
            }
        }
    }
    //核心技术
    .core-technology{
        .content-box{
            padding: 20px;
            .bottonLi{
                margin-bottom: 30px;
            }
            .el-col{
                .box-content{
                    padding: 30px 30px 0;
                    background-color: #f1f6fa;
                    height: 135px;
                    .title-text{
                        font-size: 16px;
                        height: 20px;
                        line-height: 20px;
                        font-weight: bold;
                        color: #212121;
                        margin-bottom: 18px;
                        .ab-svg{
                            width: 20px;
                            height: 20px;
                            float: left;
                            margin-right: 12px;
                        }
                    }
                    p{
                        font-size: 14px;
                        line-height: 20px;
                    }
                }
            }
        }
    }
    //合作企业
    .joint-venture{
        .content-box{
            padding: 5px;
            li{
                width: calc(33% - 30px);
                float: left;
                margin: 15px;
                height: 80px;
                background-color: #fff;
                border: 1px solid #EDEAEA;
                box-shadow: 0px 3px 29px 0px rgba(0, 0, 0, 0.06);
                position: relative;
                img{
                    width: 100%;
                    position: absolute;
                    top: 50%;
                    margin-top: -2.0833vw;
                    background-repeat: no-repeat;
                }
            }
        }
    }
}
</style>